import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initVideoEmbeds from './components/video-embeds.js';

import initMenu from './components/menu';
import initSearch from './components/search';
import initCookies from './components/cookies';
import initSignpostGallery from './components/signpost-gallery';

import initTitleReveals from './components/title-reveal.js';
import initGalleries from './components/gallery.js';
import initScrollButtons from './components/scroll-buttons.js';
import initAccordions from './components/accordions.js';

// Init cookie plugin if not home page, which is done in home.js
if (document.body.dataset.page !== 'home') {
    initCookies();
}

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const titleReveals = document.querySelectorAll('.js-title-reveal');

if (titleReveals && titleReveals.length > 0) {
    initTitleReveals(titleReveals);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const searchEl = document.querySelector('.js-menu-search');
if (searchEl) {
    initSearch(searchEl);
}

const galleries = document.querySelectorAll('.js-gallery');

if (galleries && galleries.length > 0) {
    initGalleries(galleries);
}

const videoEmbeds = document.querySelectorAll('.js-video-embed');

if (videoEmbeds && videoEmbeds.length > 0) {
    initVideoEmbeds(videoEmbeds);
}

const galleryEl = document.querySelector('.js-signpost-gallery');

if (galleryEl) {
    initSignpostGallery(galleryEl);
}

const scrollButtons = document.querySelectorAll('.js-scroll-button');

if (scrollButtons && scrollButtons.length > 0) {
    initScrollButtons(scrollButtons);
}

const accordions = document.querySelectorAll('.js-accordion');

if (accordions && accordions.length > 0) {
    initAccordions(accordions);
}

// Filters scroll to on mobile
const filters = document.querySelector('.js-filter-list');

if (filters) {
    const active = filters.querySelector('.active');

    if (active && window.innerWidth < 900) {
        active.scrollIntoView({ behavior: 'instant', inline: 'center', container: 'nearest' });
    }
}
